import { data } from "jquery";

export default {
    selectLable(value, list, key, name) {
        if (list) {
            let item = list.find(item => item[key] === value);
            return item ? item[key] + '-' + item[name] : null;
            // return item ? item[name] : null
        }
    }
}


